/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BiEdit } from "react-icons/bi";
import { MdDeleteForever } from "react-icons/md";
import { BsThreeDotsVertical } from "react-icons/bs";
import { IoSearch } from "react-icons/io5";
import Loading from "../Common/Loading";
import { FaPlus } from "react-icons/fa6";
import AddEditUsers from "./AddEditUsers";
import { deleteUsers, } from "../../Redux/AuthSlice";
import { getUrl } from "../Common/API";
import sweetAlert from "../Common/sweetAlert";
import { debounce } from "lodash";

const User = ({
    isVisible,
    setIsVisible,
    setSidebarOpen,
    sidebarOpen,
    isDark,
    setIsDark,
}) => {
    const dispatch = useDispatch();
    const { token, user } = useSelector((state) => state.root.auth);
    const authToken = `Bearer ${token}`;

    const [UserData, setUserData] = useState({
        getAllUser: [],
        EditUser: [], SearchData: []
    });
    const [UserModal, setUserModal] = useState(false);
    const [loading, setloading] = useState(false);
    const [loadFirst, setloadFirst] = useState(true);
    const [openActionMenuId, setOpenActionMenuId] = useState(null);

    useEffect(() => {
        const handleOutsideClick = () => setOpenActionMenuId(null);
        document.addEventListener("click", handleOutsideClick);
        return () => document.removeEventListener("click", handleOutsideClick);
    }, []);

    const fetchUserData = async () => {
        setloading(true)
        const response = await getUrl(`UserMaster/GetUsers?UserID=${user?.userID}`, { headers: { Authorization: authToken }, });
        if (response) {
            setUserData({ ...UserData, getAllUser: response?.data?.data, SearchData: response?.data?.data, })
            const timer = setTimeout(() => {
                setloading(false)
            }, 1000);
            return () => clearTimeout(timer);
        }
    }

    useEffect(() => {
        if (loadFirst) {
            fetchUserData()
            setloadFirst(false)
        }
    }, [loadFirst]);

    const toggleModal = () => {
        setUserModal(!UserModal)
        setUserData({ ...UserData, EditUser: [] })
    }

    const handleUserDelete = async (id) => {
        try {
            const result = await sweetAlert.confirm("Are you sure?", "Are you sure you want to delete this!");
            if (result.isConfirmed) {
                dispatch(deleteUsers(id)).then((res) => {
                    if (res.payload.status === true) {
                        fetchUserData()
                    }
                });
                sweetAlert.success("Deleted successfully");
            }
        } catch (error) {
            console.error("Error:", error);
            sweetAlert.error("An error occurred");
        }
    }

    const handleEditUser = async (id) => {
        const response = await getUrl(`UserMaster/GetLoginUser?UserID=${id}`, { headers: { Authorization: authToken }, });
        setUserData({ ...UserData, EditUser: response?.data?.data })
    }

    const handleChange = (e) => {
        const searchQuery = e.target.value.toLowerCase();
        if (searchQuery === "") {
            setUserData({ ...UserData, SearchData: UserData?.getAllUser })
        } else {
            const filterData = UserData?.getAllUser?.filter((item) => item?.userName?.toLowerCase().includes(searchQuery))
            setUserData({ ...UserData, SearchData: filterData })
        }
    }
    const debouncedOnChange = debounce(handleChange, 500);

    const totalUsers = UserData?.getAllUser?.length || 0;
    const activeUsers = UserData?.getAllUser?.filter(u => u?.status).length || 0;
    const inactiveUsers = UserData?.getAllUser?.filter(u => !u?.status).length || 0;
    const uniqueRolesCount = new Set(UserData?.getAllUser?.map(u => u?.userRoleName).filter(Boolean)).size || 0;

    return (
        <>
            <div className="flex flex-1">
                <div className="page-wrapper relative ml-auto w-[calc(100%-326px)] px-4 pt-[54px] duration-300">

                    {/* Page Header */}
                    <div className="crm-page-header">
                        <div className="flex items-center justify-between">
                            <div>
                                <h1 className="crm-page-title">Users</h1>
                                <ol className="crm-breadcrumb">
                                    <li><a href="/Analytics">Disploy</a></li>
                                    <li>/</li>
                                    <li>CRM</li>
                                    <li>/</li>
                                    <li className="active">Users</li>
                                </ol>
                            </div>
                            <button className="crm-new-btn" onClick={() => toggleModal()}>
                                <FaPlus size={11} />
                                New User
                            </button>
                        </div>
                    </div>

                    <div className="xl:w-full min-h-[calc(100vh-138px)] relative pb-14">

                        {/* Stat Cards */}
                        <div className="crm-stats-row">
                            <div className="crm-stat-card crm-card-indigo">
                                <div className="flex items-start gap-3">
                                    <div className="stat-icon stat-icon-indigo">
                                        <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                                            <circle cx="9" cy="7" r="4" />
                                            <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                                            <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                                        </svg>
                                    </div>
                                    <div>
                                        <p className="stat-label">Total Users</p>
                                        <p className="stat-value">{totalUsers}</p>
                                        <p className="stat-trend-up">↑ 2% vs last month</p>
                                    </div>
                                </div>
                            </div>
                            <div className="crm-stat-card crm-card-green">
                                <div className="flex items-start gap-3">
                                    <div className="stat-icon stat-icon-green">
                                        <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                            <circle cx="12" cy="12" r="10" />
                                            <polyline points="12 6 12 12 16 14" />
                                        </svg>
                                    </div>
                                    <div>
                                        <p className="stat-label">Active Users</p>
                                        <p className="stat-value">{activeUsers}</p>
                                        <p className="stat-trend-up">↑ 3% vs last month</p>
                                    </div>
                                </div>
                            </div>
                            <div className="crm-stat-card crm-card-red">
                                <div className="flex items-start gap-3">
                                    <div className="stat-icon stat-icon-red">
                                        <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                            <circle cx="12" cy="12" r="10" />
                                            <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
                                        </svg>
                                    </div>
                                    <div>
                                        <p className="stat-label">Inactive Users</p>
                                        <p className="stat-value">{inactiveUsers}</p>
                                        <p className="stat-trend-down">↓ 1% vs last month</p>
                                    </div>
                                </div>
                            </div>
                            <div className="crm-stat-card crm-card-blue">
                                <div className="flex items-start gap-3">
                                    <div className="stat-icon stat-icon-blue">
                                        <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                                        </svg>
                                    </div>
                                    <div>
                                        <p className="stat-label">User Roles</p>
                                        <p className="stat-value">{uniqueRolesCount}</p>
                                        <p className="stat-trend-up">Stable</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="crm-panel">
                            <div className="flex items-center justify-end px-4 py-3 border-b border-slate-100 gap-3 flex-wrap">
                                <div className="crm-search-box">
                                    <IoSearch size={14} />
                                    <input
                                        type="text"
                                        placeholder="Search users..."
                                        onChange={(e) => debouncedOnChange(e)}
                                    />
                                </div>
                            </div>

                            {loading && (<div className="h-40 flex items-center justify-center"><Loading /></div>)}
                            {!loading && (
                                <div className="relative scroll-inner">
                                    <table className="crm-table">
                                        <thead>
                                            <tr>
                                                <th scope="col" className="p-4 text-left">
                                                    USER NAME
                                                </th>
                                                <th scope="col" className="p-4">
                                                    ROLE
                                                </th>
                                                <th scope="col" className="p-4">
                                                    STATUS
                                                </th>
                                                <th scope="col" className="p-4 text-center">
                                                    ACTION
                                                </th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {UserData?.SearchData && UserData?.SearchData.length > 0 ? (
                                                UserData?.SearchData.map((item, index, arr) => {
                                                    const showUpward = index >= arr.length - 2 || arr.length <= 2;
                                                    return (
                                                        <tr className="hover:bg-slate-50 transition-colors border-b border-slate-100 text-center" key={index}>
                                                            <td className="p-4 font-medium text-slate-800 whitespace-nowrap text-left">
                                                                <div className="flex items-center gap-2">
                                                                    {item?.profilePic ? (
                                                                        <img className="w-8 h-8 rounded-full shadow-sm" src={`${item?.profilePic}`} alt="" />
                                                                    ) : (
                                                                        <div className="relative inline-flex items-center justify-center w-8 h-8 overflow-hidden bg-indigo-50 rounded-full shadow-sm">
                                                                            <span className="font-semibold text-xs text-indigo-600">{!!item?.userName && item?.userName.charAt(0).toUpperCase()}</span>
                                                                        </div>
                                                                    )}
                                                                    <span className="font-semibold text-slate-700">{item?.userName}</span>
                                                                </div>
                                                            </td>
                                                            <td className="p-4 text-sm text-slate-600 text-left">
                                                                {item?.userRoleName}
                                                            </td>
                                                            <td className="p-4 text-sm text-left">
                                                                <span className={`text-xs font-semibold px-2.5 py-0.5 rounded-full ${item?.status ? 'bg-green-50 text-green-700' : 'bg-red-50 text-red-700'}`}>
                                                                    {item?.status ? 'ACTIVE' : 'INACTIVE'}
                                                                </span>
                                                            </td>
                                                            <td className="p-4 text-center whitespace-nowrap">
                                                                <div className="relative inline-block text-left">
                                                                    <button
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            setOpenActionMenuId(openActionMenuId === item.userID ? null : item.userID);
                                                                        }}
                                                                        className="p-1.5 text-slate-500 hover:text-slate-800 hover:bg-slate-100 rounded-lg transition-colors"
                                                                    >
                                                                        <BsThreeDotsVertical size={16} />
                                                                    </button>
                                                                    {openActionMenuId === item.userID && (
                                                                        <div className={`absolute right-0 w-36 bg-white dark:bg-slate-800 border border-slate-100 dark:border-slate-700 rounded-xl shadow-xl py-1 z-50 animate-in fade-in duration-100 flex flex-col ${showUpward ? 'bottom-full mb-1 slide-in-from-bottom-1' : 'top-full mt-1 slide-in-from-top-1'}`}>
                                                                            <button
                                                                                onClick={(e) => {
                                                                                    e.stopPropagation();
                                                                                    setUserModal(true);
                                                                                    handleEditUser(item?.userID);
                                                                                    setOpenActionMenuId(null);
                                                                                }}
                                                                                className="w-full flex items-center gap-2 px-3 py-2 text-xs font-semibold text-slate-700 dark:text-slate-200 hover:bg-indigo-50 dark:hover:bg-slate-700 hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors text-left"
                                                                            >
                                                                                <BiEdit size={14} className="text-indigo-500" />
                                                                                <span>Edit</span>
                                                                            </button>
                                                                            <button
                                                                                onClick={(e) => {
                                                                                    e.stopPropagation();
                                                                                    handleUserDelete(item?.userID);
                                                                                    setOpenActionMenuId(null);
                                                                                }}
                                                                                className="w-full flex items-center gap-2 px-3 py-2 text-xs font-semibold text-red-650 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-950/30 hover:text-red-700 dark:hover:text-red-350 transition-colors text-left"
                                                                            >
                                                                                <MdDeleteForever size={14} className="text-red-500" />
                                                                                <span>Delete</span>
                                                                            </button>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    );
                                                })
                                            ) : (
                                                <tr>
                                                    <td colSpan="4" className="text-center py-4 text-slate-500">
                                                        Not Found.
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            {UserModal && <AddEditUsers setUserModal={setUserModal} fetchUserData={fetchUserData} UserData={UserData?.EditUser} toggleModal={toggleModal} />}
        </>
    );
};

export default User;

